module.exports = __webpack_public_path__ + "img/apple.5ebe53d9.png";